import { useCallback, useState } from 'react';

import { EColorVariablesV2, EPaletteModes, PANEL_THEME_COLOR_CONTENT_MAP, ThemePack } from '@/types/theme-packs.types';
import { OnColorPickerChangeResult } from '@ui/color-picker/color-picker.types';
import Container from '@ui/container/container';
import useGetWorkingProjectThemeColorsList from '@/utils/colors/use-get-working-project-theme-colors-list';
import ColorPickerHorizontal from '@ui/color-picker/color-picker-horizontal';

type TThemePackColorVariantChangeProps = {
  variant: EColorVariablesV2;
  themeMode: EPaletteModes;
  themePack?: ThemePack;
  disabled?: boolean;
  onThemePackUpdate?: (pack: ThemePack) => void;
};

const ThemePackColorVariantChange = ({
  // disabled,
  themeMode,
  themePack,
  variant,
  onThemePackUpdate,
}: TThemePackColorVariantChangeProps) => {
  const colorMeta = PANEL_THEME_COLOR_CONTENT_MAP[variant];
  const [hex] = themePack?.colors?.[themeMode]?.[colorMeta?.mappedV1Value] ?? ['#000', 100];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setWorkingColor] = useState<OnColorPickerChangeResult | null>(null);

  const presetColors = useGetWorkingProjectThemeColorsList();

  const handleColorChange = useCallback(
    (result: OnColorPickerChangeResult) => {
      if (!themePack?.colors?.[themeMode]) {
        return;
      }

      // This is intentionally not doing anything.
      // The color picker is currently in because at some point product will likely want to use it.
      setWorkingColor(result);
      const newTheme = {
        ...themePack,
        colors: {
          ...themePack.colors,
          [themeMode]: {
            ...themePack.colors[themeMode],
            [colorMeta.mappedV1Value]: [result.hex, result.opacity],
          },
        },
      };
      onThemePackUpdate?.(newTheme);
    },
    [themePack, themeMode, colorMeta.mappedV1Value, onThemePackUpdate]
  );

  if (!themePack || !hex || !colorMeta) return null;

  return (
    <Container
      width="100%"
      maxWidth="fit-content"
      minWidth="100%"
      margin="2px auto"
      height="64px"
      className="position-relative overflow-auto no-scrollbar"
    >
      <ColorPickerHorizontal
        initialColor={hex}
        presetColors={presetColors}
        onChange={handleColorChange}
        variantKey={variant}
      />
    </Container>
  );
};

export default ThemePackColorVariantChange;
